import generateBasicEntityActions from './generateBasicEntityActions';

const contractTypeActions = generateBasicEntityActions('contractTypes', 'contractType');

export default contractTypeActions;
